import React from "react";

const Footer = props => {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <ul className="pull-left list-unstyled">
          <li className="footer__copyright">
            All works copyright{" "}
            <span>
              <a href="mailto:alex@alexchan.info">Alexander Chan</a>
            </span>{" "}
            {new Date().getFullYear()}
          </li>
        </ul>
        <ul className="footer__github list-unstyled pull-right-md">
          <li>
            <a href="https://alexchan.info/demoboard">
              Demo of sprint planning
            </a>
            {/* <a href="https://github.com/alexanderchan"><i className="fa fa-github fa-lg" aria-hidden="true"/> github.com/alexanderchan</a> */}
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
